<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M12,15.75c-2.068,0-3.75-1.682-3.75-3.75c0-2.068,1.682-3.75,3.75-3.75c2.068,0,3.75,1.682,3.75,3.75
		C15.75,14.068,14.068,15.75,12,15.75z M12,9.75c-1.241,0-2.25,1.009-2.25,2.25c0,1.241,1.009,2.25,2.25,2.25
		c1.241,0,2.25-1.009,2.25-2.25C14.25,10.759,13.241,9.75,12,9.75z"/>
	<path d="M12,24c-0.414,0-0.75-0.336-0.75-0.75v-3.034c-3.983-0.356-7.109-3.482-7.466-7.466H0.75C0.336,12.75,0,12.414,0,12
		s0.336-0.75,0.75-0.75h3.034c0.357-3.983,3.483-7.109,7.466-7.466V0.75C11.25,0.336,11.586,0,12,0s0.75,0.336,0.75,0.75v3.034
		c3.983,0.357,7.109,3.483,7.466,7.466h3.034c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75h-3.034
		c-0.356,3.983-3.482,7.109-7.466,7.466v3.034C12.75,23.664,12.414,24,12,24z M12,5.25c-3.722,0-6.75,3.028-6.75,6.75
		s3.028,6.75,6.75,6.75s6.75-3.028,6.75-6.75S15.722,5.25,12,5.25z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'location-target',
    },
    name: {
      type: String,
      required: false,
      default: 'LocationTarget',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>